module.exports = __webpack_public_path__ + "static/media/menu-icon.9dc9280f.svg";